import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2b6f762e")

_pushScopeId("data-v-2b6f762e")
const _hoisted_1 = { class: "flex_spacebetween column h-100 minimumUserNotCompletedYet" }
const _hoisted_2 = { class: "text-center flex_centered column page_padding" }
const _hoisted_3 = {
  key: 0,
  class: "page_padding pb-0 pe-0"
}
const _hoisted_4 = { class: "fev_text2 fw_800 blue ps-3 mb-2" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "gradientOverlay" }, null, -1)
const _hoisted_6 = { class: "question" }
const _hoisted_7 = { class: "page_padding text-center" }
const _hoisted_8 = { class: "fw_700 blue" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_localized_text = _resolveComponent("localized-text")
  const _component_swiper_slides = _resolveComponent("swiper-slides")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_localized_text, {
        localizedKey: "app_Ciao{{name}}EssendoAppenaNatiLaNostraCommunityHaBisognoDiCrescereAncoraUnPo",
        text: "Ciao {{name}}, essendo appena nati, la nostra community ha bisogno di crescere ancora un po’.",
        object: { name: _ctx.$store.state.loggedUser.completeName },
        class: "fev_text5 fw_700"
      }, null, 8, ["object"]),
      _createVNode(_component_localized_text, {
        localizedKey: "app_ArrivatiA{{minimumUser}}ProfiliRiceveraiUnaNotificaEPotraiTrovareLaTuaAnimaGemella",
        text: "Arrivati a {{minimumUser}} profili riceverai una notifica e potrai trovare la tua anima gemella.",
        object: { minimumUser: _ctx.$store.state.consts.onboardingConfiguration.minimumUser },
        class: "fev_text5 fw_700"
      }, null, 8, ["object"])
    ]),
    (_ctx.loaded)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          _createVNode(_component_swiper_slides, {
            itemsLenght: _ctx.previewQuestions.length,
            autoHeight: false,
            slidesPerView: 'auto',
            spaceBetween: 10,
            showPagination: false,
            allowTouchMove: false,
            autoPlay: true,
            loop: true
          }, {
            default: _withId(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.previewQuestions, (item, index) => {
                return (_openBlock(), _createBlock("div", {
                  class: "swiper-slide",
                  key: index
                }, [
                  _createVNode("span", _hoisted_4, _toDisplayString(item.name) + ", " + _toDisplayString(item.years), 1),
                  _createVNode("div", {
                    class: "imageCardContainer bg_blue",
                    style: 'background-image: url(\'' + item.attachmentUrl + '\')'
                  }, [
                    _hoisted_5,
                    _createVNode("div", _hoisted_6, [
                      _createVNode("span", {
                        innerHTML: _ctx.$localizationService.getTextFromLocalizedValue(item.question)
                      }, null, 8, ["innerHTML"])
                    ])
                  ], 4)
                ]))
              }), 128))
            ]),
            _: 1
          }, 8, ["itemsLenght"])
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_7, [
      _createVNode(_component_localized_text, {
        localizedKey: "app_Utenti",
        text: "Utenti",
        class: "fev_text5 fw_700 d-block"
      }),
      _createVNode("h1", _hoisted_8, _toDisplayString(_ctx.$store.state.consts.onboardingConfiguration.currentUsers) + "/" + _toDisplayString(_ctx.$store.state.consts.onboardingConfiguration.minimumUser), 1)
    ])
  ]))
})